export default {
    methods: {
        print() {
            return {
                dispensacao(agendamento) {

                    const page = window.open('', Math.random())

                    const date = new Date().toLocaleString();

                    const image = page.document.createElement('img')

                    image.style.height = '30px';

                    image.src = agendamento.logotipo ? require(`@/assets/cliente/logotipo/${agendamento.logotipo}`) : null

                    let prefeitura = agendamento.nomePrefeitura ? `
                        <strong>PREFEITURA DE ${agendamento.nomePrefeitura}</strong>
                        ` : ''

                    let ramoAtividade = agendamento.ramoAtividade ? `Secretaria Municipal de ${agendamento.ramoAtividade}` : ''
                    let unidade = agendamento.unidade ?  agendamento.unidade : ''
                    let telefone = agendamento.telefone ? `Telefone: ${agendamento.telefone}` : ''

                    let sistemaNome = agendamento.sistemaNome ? `${agendamento.sistemaNome}` : ''
                    let sistemaVersao = agendamento.sistemaVersao ? `${agendamento.sistemaVersao}` : ''
                    let responsavel = ` <strong>Operador(es):</strong><br />${agendamento.operadores}`

                    let nomeSocial = agendamento.pacienteNomeSocial ? ` (${agendamento.pacienteNomeSocial})` : ''

                    let table = '<table>'

                    table = table + `
                        <tr>
                            <th colspan="3" style="text-align: center; font-size: 14px">
                                DESCRIÇÃO
                            </th>
                        </tr>
                        <tr>
                            <td colspan="3" style="text-align: center; font-size: 12px">
                                (Entrega: ${agendamento.dataEntrega} / Reimpressão: ${agendamento.dataAtual})
                            </td>
                        </tr>
                        <tr>
                            <td colspan="3" style="text-align: center; padding-bottom:5px; font-size: 12px">
                                Horário Atendimento: ${agendamento.horaAtendimento}hs
                            </td>
                        </tr>
                    `

                    table = table + `
                        <tr>
                            <td colspan="3" style="border-bottom:1px dotted #dbdbdb; border-top:2px dotted #dbdbdb;">
                                <strong>MÉDICO:</strong><br />${agendamento.medicoNome}
                            </td>
                        </tr>
                    `

                    agendamento.medicamentos.forEach(exame => {

                        table = table + `
                            <tr>
                                <td colspan="3"><strong>MEDICAMENTO: </strong><br />${exame.material.descricaoCompleta}</td>
                            </tr>
                        `

                        exame.entradaItens.forEach(entrada => {

                            table = table + `
                                <tr>
                                    <td>Lote: ${entrada.lote ?? '-'}</td>
                                    <td>Valid. Rec.: ${entrada.validadeLote ?? '-'}</td>
                                    <td>Qtde: Solic: ${exame.prescrito}</td>
                                </tr>
                            `

                            table = table + `
                                <tr>
                                    <td>Qtde. Entr.: ${entrada.quantidadeSaida}</td>
                                    <td colspan="2">Próxima retirada: ${exame.proximaRetirada}</td>
                                </tr>
                            `

                            table = table + `
                                <tr>
                                    <td colspan="3" style="border-bottom:1px dotted #dbdbdb"></td>
                                </tr>
                            `
                        })
                    })

                    table.concat(`</table>`)

                    page.document.write(`
                         <head>
                            <title>Recibo de medicamento</title>

                            <style>
                                * {
                                    font-family: 'Arial', Gadget, sans-serif;
                                }
                                body {
                                    max-width: max-content;
                                    margin: auto;
                                }
                                table.report-container {
                                    page-break-after: always;
                                }
                                thead.report-header {
                                    display: table-header-group;
                                }
                                tfoot.report-footer {
                                    display: table-footer-group;
                                    border: 0;
                                }
                                table, tbody tr, tbody td {
                                    border: 0;
                                }
                                body {
                                    max-width: max-content;
                                    margin: auto;
                                }
                                table.report-container {
                                    page-break-after: always;
                                }
                                thead.report-header {
                                    display: table-header-group;
                                }
                                tfoot.report-footer {
                                    display: table-footer-group;
                                    border: 0;
                                }
                                table, tbody tr, tbody td {
                                    border: 0;
                                }
                                table {
                                    width: 8.0cm;
                                    max-width: 8.0cm;
                                    border-collapse: collapse;
                                    font-size: 12px;
                                }
                                .content {
                                    align-items: center;
                                    display: flex;
                                    flex-direction: column;
                                    width: 100%;
                                }
                                .paper {
                                    width: 8.0cm;
                                }
                                .container {
                                    display: flex;
                                    flex-direction: column;
                                    padding: 0 0.1cm;
                                }
                                #header {
                                    align-items: center;
                                    display: flex;
                                    flex-direction: row;
                                    justify-content: space-between;
                                    border:  1px solid #000000;
                                }
                                #paciente {
                                    align-items: center;
                                    display: flex;
                                    flex-direction: row;
                                    justify-content: space-between;
                                    font-size:12px;
                                    padding-bottom:5px
                                }
                                #pedido {
                                    align-items: center;
                                    display: flex;
                                    flex-direction: row;
                                    justify-content: space-between;
                                }
                                #obs {
                                    align-items: center;
                                    display: flex;
                                    flex-direction: row;
                                    justify-content: space-between;
                                    margin-bottom:  12px;
                                }
                                #left-col {
                                    flex-grow: 1;
                                }
                                #right-col {
                                    flex-grow: 1;
                                    font-size: 0.3cm;
                                    text-align: right;
                                }
                                h1 {
                                    background-color: #000000;
                                    color: #FFFFFF;
                                    font-size: 0.25cm;
                                    margin: 0;
                                    padding: 0.05cm;
                                    text-align: center;
                                }
                                p {
                                    font-size: 12px;
                                    margin: 0.05cm 0;
                                    padding: 0;
                                }
                                .line {
                                   border-bottom: 1px dotted #c7c7c7;
                                   margin: 5px 0
                                }
                                .lineBottom {
                                   border-bottom: 2px solid #000000;
                                }
                                .pr-10 {
                                   padding-right: 12px;
                                }
                                .pr-10 {
                                   padding-right: 12px;
                                }
                                fieldset{
                                    width: 100%;
                                    align-items: center;
                                    display: flex;
                                    flex-direction: row;
                                    padding: 0 5px;
                                }
                                legend {
                                    font-family: Arial, Helvetica, sans-serif;
                                    font-size: 15px;
                                    font-weight: 100!important;
                                }
                                #rodape-left {
                                    width: 25%;
                                    float: left;
                                    margin-top: 5px;
                                    font-size: 12px;
                                    text-align:  left;
                                }
                                #rodape-right {
                                    width: 75%;
                                    float: right;
                                    margin-top: 5px;
                                    font-size: 12px;
                                    text-align: right;
                                }
                                table {
                                    width: 100%;
                                }
                                tr {
                                    border: 1px solid black;
                                    border-collapse: collapse;
                                }
                                th {
                                    font-size: 12px;
                                }
                                td {
                                    font-size: 12px;
                                }
                                #img {
                                    display: flex;
                                    justify-content: center;
                                    align-items: center;
                                }
                                #prefeitura {
                                   text-align: center;
                                   padding-top: 5px;
                                   text-transform: uppercase;
                                }
                                #ramoAtividade {
                                    text-align: center;
                                }
                                #unidade {
                                    text-align: center;
                                    text-transform: uppercase;
                                }
                                #telefone {
                                    text-align: center;
                                    padding-bottom: 5px;
                                }
                                #prontuario {
                                    float: left;
                                    width: 30%;
                                }
                                #dataNascimento {
                                    padding-left: 5%;
                                    float: left;
                                    width: 63%;
                                }
                                #responsavel {
                                    clear:  both;
                                    width: 100%;
                                    padding-bottom:12px;
                                }
                                .titulo {
                                    font-size: 14px;
                                    text-align: center;
                                    padding: 12px 0 3px 0;
                                }
                                .b-0 {
                                    border: 0;
                                }
                                .b-0 {
                                    border: 0;
                                }
                                #assinatura {
                                    width: 80%;
                                    border-top: 1px solid #000;
                                    margin: 0 auto;
                                    margin-top:12px;
                                    text-align:center;
                                }
                                #td-assinatura {
                                    padding:12px;
                                    text-align:center;
                                }
                            </style>
                        </head>

                        <body>

                            <table class="report-container">
                                <thead class="report-header">
                                    <tr class="b-0">
                                        <th class="report-header-cell">
                                            <div class="header-info">

                                            </div>
                                        </th>
                                    </tr>
                                </thead>

                                <tfoot class="report-footer">
                                    <tr class="b-0">
                                        <td class="report-footer-cell">
                                            <div class="footer-info">

                                            </div>
                                        </td>
                                    </tr>
                                </tfoot>

                                <tbody class="report-content">
                                    <tr>
                                        <td class="report-content-cell">
                                            <div id="img"></div>
                                            <div id="prefeitura"></div>
                                            <p id="ramoAtividade"></p>
                                            <p id="unidade"></p>
                                            <p id="telefone"></p>
                                            <p id="responsavel"></p>
                                            <div class="lineBottom"></div>
                                            <div class="titulo"><strong>RECIBO DE MEDICAMENTO</strong></div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td class="report-content-cell">
                                            <div id="paciente">
                                                <fieldset>
                                                    <legend>Dados do paciente</legend>
                                                    <div id="left-col">
                                                        <p>
                                                            <strong>Paciente:</strong><br />
                                                            ${agendamento.pacienteNome} <strong>${nomeSocial}</strong>
                                                        </p>
                                                        <p id="prontuario">
                                                            <strong>Prontuário:</strong><br />
                                                            ${agendamento.prontuario}
                                                        </p>
                                                        <p id="dataNascimento">
                                                            <strong>Data nascimento:</strong><br />
                                                            ${agendamento.dataNascimento}
                                                        </p>
                                                    </div>
                                                </fieldset>
                                            </div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td class="report-content-cell" id="table">

                                        </td>
                                    </tr>

                                    <tr>
                                        <td class="report-content-cell" id="td-assinatura">
                                            <div id="assinatura">Assinatura do paciente</div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td class="report-content-cell">
                                            <div class="lineBottom"></div>

                                            <div>
                                                <div id="rodape-left">
                                                    <span id="sistemaNome"></span>
                                                    <span id="sistemaVersao"></span>
                                                </div>
                                                <div id="rodape-right">
                                                    <span>Impresso por: ${agendamento.usuario}</span><br/>
                                                    <span>Data/hora da impressão: ${date}</span>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </body>
                    `)

                    page.document.getElementById('img').appendChild(image)
                    page.document.getElementById('table').innerHTML = table
                    page.document.getElementById('prefeitura').innerHTML = prefeitura
                    page.document.getElementById('ramoAtividade').innerHTML = ramoAtividade
                    page.document.getElementById('unidade').innerHTML = unidade
                    page.document.getElementById('telefone').innerHTML = telefone
                    page.document.getElementById('sistemaNome').innerHTML = sistemaNome
                    page.document.getElementById('sistemaVersao').innerHTML = sistemaVersao
                    page.document.getElementById('responsavel').innerHTML = responsavel


                    image.onload = function(){

                        page.print()
                        page.close()
                    }
                },
            }
        }
    },
}